import { useEffect, useMemo, useState } from 'react';
import { Platform } from 'react-native';
import { createPreviewHost, connectPreviewHost, HTML_PREVIEW_ALLOW, ISOLATED_HTML_SANDBOX } from '@/lib/htmlPreviewHost';
import { withHtmlPreviewDiagnostics } from '@/constants/utils/html_preview_runtime';

export default function useHtmlPreviewHost({ frameRef, html, sourceKey, documentKey, enabled = true }) {
  const [revision, setRevision] = useState(0);
  const [error, setError] = useState('');
  const host = useMemo(() => Platform.OS === 'web' && typeof window !== 'undefined' && html
    ? createPreviewHost(sourceKey, window.location.origin, documentKey || html) : null, [sourceKey, html, documentKey, revision]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    setError('');
    if (!host || !enabled) return undefined;
    const receive = event => {
      const data = event.data;
      if (event.source !== frameRef.current?.contentWindow || event.origin !== host.origin || data?.channel !== 'gab-html-runtime-v1' || data.session !== host.session) return;
      if (data.type === 'error' && typeof data.message === 'string') setError(previous => previous || `This page encountered a problem: ${data.message.slice(0, 500)}`);
    };
    window.addEventListener('message', receive);
    const cleanup = connectPreviewHost({ host, getWindow: () => frameRef.current?.contentWindow,
      html: withHtmlPreviewDiagnostics(html, host.session, window.location.origin), onError: setError });
    return () => { cleanup(); window.removeEventListener('message', receive); };
  }, [host, enabled, frameRef, html]);
  return {
    error, setError, restart: () => setRevision(value => value + 1), origin: host?.origin, frameKey: host?.session,
    frameProps: { src: host?.src, sandbox: ISOLATED_HTML_SANDBOX, allow: HTML_PREVIEW_ALLOW, allowFullScreen: true, referrerPolicy: 'no-referrer' },
  };
}
